(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tmi-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    function activate(event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var group = target.closest('[data-tmi-group]');
      if (!group) return;

      var mega = group.closest('[data-tmi-mega]');
      if (!mega) return;

      var index = group.getAttribute('data-tmi-group');

      mega.querySelectorAll('[data-tmi-group]').forEach(function (element) {
        element.toggleAttribute('data-active', element.getAttribute('data-tmi-group') === index);
      });

      mega.querySelectorAll('[data-tmi-panel]').forEach(function (element) {
        element.toggleAttribute('data-active', element.getAttribute('data-tmi-panel') === index);
      });

      mega.querySelectorAll('[data-tmi-promo]').forEach(function (element) {
        element.toggleAttribute('data-active', element.getAttribute('data-tmi-promo') === index);
      });
    }

    document.addEventListener('pointerover', activate);
    document.addEventListener('focusin', activate);
  })();
  } catch(e) { console.error(e); }
})();

})();
